import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
  token: string | null;
  isAuthenticated: boolean;
  tenantName: string | null;
  clientID: string | null;
  user: any;
  loading: boolean;
}

export interface SetAuthPayload {
  token: string | null;
  tenantName: string | null;
  clientID: string | null;
}

const initialState: AuthState = {
  token: null,
  tenantName: null,
  clientID: null,
  isAuthenticated: false,
  user: null,
  loading: true,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken(state, action: PayloadAction<SetAuthPayload>) {
      state.token = action.payload.token;
      state.tenantName = action.payload.tenantName;
      state.clientID = action.payload.clientID;
      state.isAuthenticated = !!action.payload.token;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setUser(state, action: PayloadAction<any>) {
      state.user = action.payload;
    },
    setAuthenticated(state, action: PayloadAction<boolean>) {
      state.isAuthenticated = action.payload;
    },
  },
});

export const { setToken, setLoading, setAuthenticated, setUser } = authSlice.actions;
export default authSlice.reducer;
